var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import arrowCartridge from '@assets/images/arrow.png';
import { ComponentWithPosition } from '@components/abstract/ComponentWithPosition';
import { CARTRIDGE_SIZE } from '@static/game';
var ArrowCartridge = /** @class */ (function (_super) {
    __extends(ArrowCartridge, _super);
    function ArrowCartridge(x, y) {
        var _this = _super.call(this, x, y, CARTRIDGE_SIZE) || this;
        _this._power = 10;
        _this._speed = 4;
        _this._cartridgeImage = new Image();
        _this._cartridgeImage.src = arrowCartridge;
        return _this;
    }
    ArrowCartridge.prototype.move = function () {
        this._x += this._speed;
    };
    ArrowCartridge.prototype.draw = function () {
        this._gameConfigurator.context.drawImage(this._cartridgeImage, this._x, this._y - CARTRIDGE_SIZE / 2, 32, 10);
    };
    Object.defineProperty(ArrowCartridge.prototype, "power", {
        get: function () {
            return this._power;
        },
        enumerable: false,
        configurable: true
    });
    return ArrowCartridge;
}(ComponentWithPosition));
export { ArrowCartridge };
